import React, { type FC, useState } from 'react';

export type FinalDecisionActionsMenuProps = {
  disabled?: boolean;
  onSelectContracting: () => void;
  onSelectEmail?: () => void;
  // A general email draft: no offer and no listing agent
  onSelectDraft?: () => void;
  // An email to a wholesaler offering the Max Bid (not a contract)
  onSelectWholesaleOffer?: () => void;
}

// "Actions" dropdown next to Print / Export PDF. Each future action (Automatic Contracting first) is one item.
const FinalDecisionActionsMenu: FC<FinalDecisionActionsMenuProps> = ({ disabled, onSelectContracting, onSelectEmail, onSelectDraft, onSelectWholesaleOffer }) => {
  const [ open, setOpen ] = useState(false);

  return (
    <div className='relative inline-block text-left'>
      <button
        type='button'
        id='fdm-actions-button'
        data-tag='fdm-actions-button'
        aria-haspopup='menu'
        aria-expanded={open}
        disabled={disabled}
        title={disabled ? 'No properties ready for Final Decision' : 'Actions for this list'}
        className='rounded bg-white px-3 py-2 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50'
        onClick={() => setOpen((value) => !value)}
      >
        Actions ▾
      </button>
      {open && (
        <div role='menu' className='absolute right-0 z-20 mt-1 w-56 rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5'>
          <button
            type='button'
            role='menuitem'
            data-tag='fdm-action-automatic-contracting'
            className='block w-full px-4 py-2 text-left text-xs text-gray-700 hover:bg-gray-100'
            onClick={() => {
              setOpen(false);
              onSelectContracting();
            }}
          >
            Automatic Contracting
          </button>
          {onSelectEmail && (
            <button
              type='button'
              role='menuitem'
              data-tag='fdm-action-email-listing-agent'
              className='block w-full px-4 py-2 text-left text-xs text-gray-700 hover:bg-gray-100'
              onClick={() => {
                setOpen(false);
                onSelectEmail();
              }}
            >
              Email Listing Agent
            </button>
          )}
          {onSelectDraft && (
            <button
              type='button'
              role='menuitem'
              data-tag='fdm-action-draft-email'
              title='A plain email draft from your email template: no offer, no listing agent'
              className='block w-full px-4 py-2 text-left text-xs text-gray-700 hover:bg-gray-100'
              onClick={() => {
                setOpen(false);
                onSelectDraft();
              }}
            >
              Draft Email
            </button>
          )}
          {onSelectWholesaleOffer && (
            <button
              type='button'
              role='menuitem'
              data-tag='fdm-action-wholesale-offer'
              title='Email a wholesaler the most you will pay for their deal. Not a contract.'
              className='block w-full px-4 py-2 text-left text-xs text-gray-700 hover:bg-gray-100'
              onClick={() => {
                setOpen(false);
                onSelectWholesaleOffer();
              }}
            >
              Make Wholesale Offer
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default FinalDecisionActionsMenu;
